import { FocusEvent } from 'react';

import {
  FormatGroupLabelType,
  FormatOptionLabelType,
  MultiSelectDataType,
  MultiSelectInputChangeCallbackType,
  MultiSelectMixedDataType
} from './types';
import { createFilter } from 'react-select';

export type MultiSelectValueType =
  | MultiSelectMixedDataType
  | MultiSelectMixedDataType[]
  | null;

export interface MultiSelectProps {
  autoFocus?: boolean;
  blurInputOnSelect?: boolean;
  classNamePrefix?: string | null;
  closeMenuOnSelect?: boolean;
  defaultValue?: MultiSelectDataType[] | MultiSelectDataType | null;
  disabled?: boolean;
  emptyValue?: MultiSelectDataType | null;
  error?: string | null;
  errorClassName?: string;
  filterConfig?: Parameters<typeof createFilter>[0];
  i18nLabel?: string | null;
  i18nPlaceholder?: string;
  inputWrapperClassName?: string | null;
  isClearable?: boolean;
  labelClassName?: string;
  menuIsOpen?: boolean;
  menuPlacement?: 'auto' | 'bottom' | 'top';
  menuPosition?: 'absolute' | 'fixed';
  name?: string;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onMenuClose?: () => void;
  onMenuOpen?: () => void;
  openMenuOnFocus?: boolean;
  placeholder?: string | null;
  showError?: boolean;
  withPortal?: boolean;
}

export interface MultiSelectOptionalProps {
  data?: MultiSelectMixedDataType[];
  formatGroupLabel?: FormatGroupLabelType;
  formatOptionLabel?: FormatOptionLabelType;
  isLoading?: boolean;
  isOptionDisabled?: (option: MultiSelectMixedDataType) => boolean;
  isSearchable?: boolean;
  multi?: boolean;
  onInputChange?: MultiSelectInputChangeCallbackType;
  onMenuScrollToBottom?: () => void;
  optionsLoading?: boolean;
  sortable?: boolean;
}

export const defaultFilterConfig = {
  ignoreAccents: true,
  ignoreCase: true,
  matchFrom: 'any' as const,
  stringify: (option) => `${option.label} ${option.value}`,
  trim: true
};

export const filterConfigOnlyLabels = {
  ...defaultFilterConfig,
  stringify: (option: MultiSelectDataType) => option.label as string
};
